import { SgCurrencyPairPickerProvider } from './context.tsx';
import { CurrencyPairInput } from './CurrencyPairInput.tsx';
import { CurrencyPairList } from './CurrencyPairList.tsx';
import { CurrencyPairTooltipError } from './CurrencyPairTooltipError.tsx';

type SgCurrencyPairPickerProps = {
  // the current currency pair
  value?: string;

  // all currency pairs available
  currencyPairs?: string[];

  // the function to call when the value changes
  onChange?: (value: string | undefined) => void;

  // the ID of the input element for testing purposes
  'data-e2e'?: string;
};

export const SgCurrencyPairPicker = (props: SgCurrencyPairPickerProps) => {
  const { value = '', currencyPairs, onChange, 'data-e2e': dataE2e } = props;

  return (
    <SgCurrencyPairPickerProvider value={value} isRequired={true} currencyPairs={currencyPairs} onChange={onChange}>
      <CurrencyPairInput data-e2e={dataE2e} />
      <CurrencyPairList />
      <CurrencyPairTooltipError />
    </SgCurrencyPairPickerProvider>
  );
};
